import { ajax } from "discourse/lib/ajax";
import { deepMerge } from "discourse/lib/object";
import PreloadStore from "discourse/lib/preload-store";
import { userPath } from "discourse/lib/url";
import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class AdminInvite extends DiscourseRoute {
  titleToken() {
    return i18n("admin_invite.title");
  }

  async model(params) {
    if (PreloadStore.get("admin_invite")) {
      const adminInvite = await PreloadStore.getAndRemove("admin_invite");
      if (adminInvite) {
        return deepMerge(params, adminInvite);
      }
    }
  }

  afterModel({ token }) {
    // confirm token here so email clients who crawl URLs don't invalidate the link
    if (token) {
      return ajax(userPath(`confirm-email-token/${token}.json`));
    }
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.setProperties({
      accountUsername: model.username === "user1" ? "" : model.username,
      accountName: model.name,
    });
  }

  activate() {
    super.activate(...arguments);
    this.controllerFor("application").showSiteHeader = false;
  }

  deactivate() {
    super.deactivate(...arguments);
    this.controllerFor("application").showSiteHeader = true;
  }
}
